export default __webpack_public_path__ + "static/media/406.0f77cc6c.png";